import type { NextPage } from "next";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { accountApi } from "@/apis/accounts/accountApi";
import { Account } from "@/apis/clients";
import { ApiResponseError } from "@/apis/errors";
import { BasicInfo } from "@/components/organisms/accounts/index/BasicInfo";
import { PageHeader } from "@/components/organisms/header/PageHeader";
import { AccountPageLayout } from "@/components/templates/accounts/AccountPageLayout";
import { useSystemMessage } from "@/hooks/systemMessage";
import useApiResponseErrorHandler from "@/hooks/useApiResponseErrorHandler";
import useGetPrefectures from "@/hooks/useGetPrefectures";
import useGetUserIndustries from "@/hooks/useGetUserIndustries";
import { useLoading } from "@/states/loading/operations";

const AccountPage: NextPage = () => {
  const withLoading = useLoading();
  const systemMessage = useSystemMessage();
  const { handlePageError } = useApiResponseErrorHandler();
  const { prefectures } = useGetPrefectures();
  const { userIndustries } = useGetUserIndustries();
  const [account, setAccount] = useState<Account>();
  const router = useRouter();

  const getUserAccount = async () => {
    await withLoading(async () => {
      const res = await accountApi.getAccount();
      setAccount(res.data);
    });
  };

  useEffect(() => {
    Promise.all([getUserAccount()]).catch((e) => {
      if (e instanceof ApiResponseError) {
        void handlePageError(e);
      }
    });
  }, []);

  return (
    <AccountPageLayout>
      <div className="md:mt-3">
        <PageHeader title="アカウント情報" />
      </div>
      <div className="space-y-9 md:mt-10 md:space-y-8">
        {account && prefectures && userIndustries && (
          <>
            <BasicInfo
              account={account}
              prefMaster={prefectures}
              userIndustryMaster={userIndustries}
            />
            {/* <section
              id="basic-info"
              className="py-5 px-4 rounded-[22px] border md:py-6 md:rounded-lg"
            >
              退会をご希望の方は、
              <a
                href="mailto:Yoyacoo489@gmail.com?subject=【Yoyacoo】退会について"
                className="underline"
              >
                Yoyacoo489@gmail.com
              </a>
              までご連絡ください。
            </section> */}
          </>
        )}
      </div>
    </AccountPageLayout>
  );
};

export default AccountPage;
